<div class="rn-page">
  <message-dialog
    #stagingWarningDialog
    [showAffirm]="false"
    [showClose]="true"
    [verticallyCenter]="true"
  >
    <div class="staging-warning-content">
      <i class="fa fa-exclamation-triangle staging-warning-icon" aria-hidden="true"></i>
      <h2 class="staging-warning-title">STOP!</h2>
      <p class="staging-warning-message">{{ stagingWarningMessage }}</p>
    </div>
  </message-dialog>
  <rn-progress-tabs [tabs]="progressTabs" [selectedTabId]="currentTab"></rn-progress-tabs>
  <rn-file-launcher (statusChanged)="updateProgressTabs($event)">
    <div cancel-link class='link-container'><a routerLink="/file-engine-jobs">Cancel</a></div>
  </rn-file-launcher>
</div>
